/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Partner_Org_Freeze_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Suspend {orgName}?" |
*
* @param {Partner_Org_Freeze_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_freeze_confirm_title = /** @type {((inputs: Partner_Org_Freeze_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Freeze_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.orgName} sperren?`)
	return /** @type {LocalizedString} */ (`Suspend ${i?.orgName}?`)
});